<template>
  <main>
    <!-- <Header /> -->
    <div class="main-content">
      <slot />
    </div>
    <!-- <Footer /> -->
  </main>
</template>
